if (!customElements.get('pb-information-tabs')) {
  customElements.define('pb-information-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const nav = this.querySelector('.pb-information__nav');
      const tabs = Array.from(nav.querySelectorAll('a'));
      const panels = Array.from(this.querySelectorAll('.pb-information__panel'));
      const decodeLabel = value => {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = value;
        return textarea.value;
      };
      const detailsTitle = decodeLabel(this.dataset.detailsTitle || '');
      const description = this.querySelector('[data-product-description]');
      const plain = description.querySelector('.metafield-multi_line_text_field');
      if (plain) {
        const text = plain.innerHTML.replace(/<br\s*\/?\s*>/gi, '\n');
        const holder = document.createElement('div');
        holder.innerHTML = text;
        const lines = holder.textContent.split('\n').map(line => line.trim()).filter(Boolean);
        description.replaceChildren();
        let list;
        lines.forEach(line => {
          if (/^[•●]\s*/.test(line)) {
            if (!list) { list = document.createElement('ul'); description.append(list); }
            const li = document.createElement('li');
            li.textContent = line.replace(/^[•●]\s*/, '');
            list.append(li);
          } else {
            list = null;
            const node = document.createElement(/^(details|specifications|jewelry care|recommended for everyday wear)$/i.test(line) ? 'h3' : 'p');
            node.textContent = line;
            description.append(node);
          }
        });
      }
      description.querySelectorAll('h2,h3,h4,h5,h6').forEach(heading => {
        if (!/^recommended for everyday wear$/i.test(heading.textContent.trim())) return;
        let next = heading.nextSibling;
        while (next && !(next.nodeType === 1 && /^H[1-6]$/.test(next.tagName))) {
          const following = next.nextSibling;
          next.remove();
          next = following;
        }
        heading.remove();
      });
      const headings = Array.from(description.querySelectorAll('h2,h3,h4'));
      const careHeading = headings.find(h => /^jewel(le)?ry care$/i.test(h.textContent.trim()) || /^jewelry care$/i.test(h.textContent.trim()));
      if (careHeading && careHeading.parentElement === description) {
        const fragment = document.createDocumentFragment();
        let next = careHeading.nextSibling;
        while (next && !(next.nodeType === 1 && /^H[1-6]$/.test(next.tagName))) {
          const following = next.nextSibling;
          fragment.append(next);
          next = following;
        }
        careHeading.remove();
      }
      const detailHeading = Array.from(description.children).find(node => /^H[1-6]$/.test(node.tagName) && /details|specifications|sizing/i.test(node.textContent));
      const firstList = description.querySelector(':scope > ul');
      const splitAt = detailHeading || firstList;
      const copyElement = this.querySelector('[data-key-details-copy]');
      const optionsElement = this.querySelector('[data-product-options]');
      const copy = copyElement ? Object.fromEntries(Object.entries(JSON.parse(copyElement.textContent)).map(([key, value]) => [key, decodeLabel(value)])) : {};
      const options = optionsElement ? JSON.parse(optionsElement.textContent) : [];
      const sourceItems = Array.from(description.querySelectorAll('li')).map(li => li.textContent.trim());
      const sourceText = description.textContent;
      const materialOptions = options.filter(option => /material/i.test(option.name)).flatMap(option => option.values.map(value => typeof value === 'string' ? value : value.name || ''));
      const materialSource = materialOptions.length ? materialOptions.join(' ') : sourceItems.find(line => /brass|sterling|14k/i.test(line)) || '';
      const hasBrass = /brass/i.test(materialSource);
      const hasSilver = /silver|sterling|925/i.test(materialSource);
      const hasGold = /14\s*k|14\s*karat/i.test(materialSource);
      const materials = [hasBrass && copy.brass, hasSilver && copy.silver, hasGold && copy.gold].filter(Boolean);
      const dimensionLines = sourceItems.filter(line => /dimensions?|(?:width|thickness|height|diameter)\s*:|^(?:lengths?|total length|chain length)\s*:/i.test(line) && /\d/.test(line));
      let dimensionText = dimensionLines.map(line => line.replace(/^[^:]*dimensions?\s*:\s*/i, '').replace(/\.$/, '')).join('; ');
      if (this.dataset.confirmedDimensions) dimensionText = decodeLabel(this.dataset.confirmedDimensions);
      const birthstone = /birthstone/i.test(sourceText) && !/stone-free|no birthstones|without (?:a )?birthstone/i.test(sourceText);
      const fixedStones = sourceItems.find(line => /lab.grown diamonds|pavé.set diamonds|pave.set diamonds/i.test(line));
      const details = [];
      if (materials.length) details.push([copy.materials_label, materials.length > 1 ? materials.slice(0, -1).join(', ') + (materials.length > 2 ? ', or ' : ' or ') + materials.at(-1) + '.' : materials[0] + '.']);
      if (hasBrass || hasSilver) details.push([copy.plating_label, hasBrass && hasSilver ? copy.plated_both : hasSilver ? copy.plated_silver : copy.plated_brass]);
      else if (hasGold) details.push([copy.colors_label, copy.gold_colors]);
      if (dimensionText) details.push([copy.dimensions_label, dimensionText + '.']);
      if (birthstone) details.push([copy.birthstones_label, copy.birthstone_detail]);
      else if (fixedStones) details.push([copy.stones_label, fixedStones.replace(/\.$/, '') + '.']);
      if (materials.length) details.push(['', copy.nickel_free]);
      this.dataset.missingDimensions = String(!dimensionText);
      if (details.length && copyElement) {
        const panel = panels[0];
        const grid = document.createElement('div');
        grid.className = 'pb-information__details-grid';
        const story = document.createElement('div');
        const specs = document.createElement('div');
        specs.className = 'pb-information__specifications';
        story.append(panel.querySelector('h2'));
        while (description.firstChild && description.firstChild !== splitAt) story.append(description.firstChild);
        const heading = document.createElement('h3');
        heading.textContent = detailsTitle;
        specs.append(heading);
        const list = document.createElement('ul');
        details.slice(0, 5).forEach(([label, value]) => {
          const item = document.createElement('li');
          if (label) {
            const strong = document.createElement('strong');
            strong.textContent = label + ': ';
            item.append(strong);
          }
          item.append(document.createTextNode(value));
          list.append(item);
        });
        specs.append(list);
        description.remove();
        grid.append(story, specs);
        panel.append(grid);
      }
      // Keep automatic offer transitions and browser anchoring from scrolling titles.
      let savedTabScroll = nav.scrollLeft;
      let gestureUntil = 0;
      let touching = false;
      nav.style.scrollBehavior = 'auto';
      nav.style.overflowAnchor = 'none';
      nav.addEventListener('pointerdown', () => { touching = true; gestureUntil = Date.now() + 1500; }, {passive:true});
      const endGesture = () => { touching = false; gestureUntil = Date.now() + 800; };
      nav.addEventListener('pointerup', endGesture, {passive:true});
      nav.addEventListener('pointercancel', endGesture, {passive:true});
      nav.addEventListener('touchstart', () => { touching = true; }, {passive:true});
      nav.addEventListener('touchend', endGesture, {passive:true});
      nav.addEventListener('wheel', () => { gestureUntil = Date.now() + 800; }, {passive:true});
      nav.addEventListener('scroll', () => {
        if (touching || Date.now() < gestureUntil) savedTabScroll = nav.scrollLeft;
        else if (Math.abs(nav.scrollLeft - savedTabScroll) > 1) nav.scrollLeft = savedTabScroll;
      }, {passive:true});
      nav.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].tabIndex = 0;
      });
      const activate = (index, focus = false, scroll = true) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          panels[i].classList.remove('is-entering');
        });
        panels[index].classList.add('is-entering');
        if (focus) tabs[index].focus({preventScroll:true});

      };
      nav.addEventListener('click', event => {
        const tab = event.target.closest('[role=tab]');
        if (!tab) return;
        event.preventDefault();
        activate(tabs.indexOf(tab));
      });
      nav.addEventListener('keydown', event => {
        let index = tabs.indexOf(document.activeElement);
        if (index < 0) return;
        if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') index = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else return;
        event.preventDefault();
        activate(index, true);
      });
      this.dataset.ready = 'true';
      activate(0, false, false);
    }
  });
}

